import {getActionDescription, getApiActionsForGivenModule} from 'amc-common-components';
import {createAction, props} from '@ngrx/store';
import {Page, SubPage, Vendor} from '@entities/left-panel/left-panel.interface';

/**
 * Auxiliary Module name variable for creating unique actions.
 */
const moduleName = 'LeftPanel';
/**
 * Auxiliary variable for creating actions to load data.
 */
const getApiActions = getApiActionsForGivenModule(moduleName);
/**
 * Auxiliary function for creating a unique description of the action.
 * @param {string} id
 * @param {string} description
 * @returns {string}
 */
const getDescription = (id: string) => getActionDescription(moduleName, id);

/**
 * Auxiliary export declaration actions for Dashboard Actions Page.
 */
export const LeftPanelActions = {
	load: getApiActions('Pages', props<{pages: Page[]}>()),
	selection: createAction(
		getDescription('Pages selection succeeded'),
		props<{
			page: Page;
			subPage?: SubPage;
			vendor?: Vendor;
		}>()
	),
	toggle: createAction(getDescription('Panel toggle')),
};
